import styled from "styled-components";
import { respondTo } from "../../styles";

export const TextInput = styled.input`
  height: 43px;
  width: ${(props) => props.customWidthMobile || "auto"};
  padding-left: 20px;

  ${respondTo.md`
    width: ${(props) => props.customWidth || "auto"};
  `}
`;
